import {FC} from 'react';
import {Redirect} from 'wouter';

interface DefaultPageProps {}

export const DefaultPage: FC<DefaultPageProps> = () => {
  return <Redirect to="/pick" />;
};

DefaultPage.displayName = 'DefaultPage';
